import { RouteConfig } from 'vue-router';
import Search from '@/apps/search/Search.vue';
import { requireSeeker } from '@/router/guards/authGuards';
import combineGuards from '@/router/guards/helpers';
import searchCareTypeGuard from '@/router/guards/searchCareTypeGuard';

const searchRoutes: RouteConfig[] = [
  {
    path: '/availability/search',
    name: 'Search',
    component: Search,
    beforeEnter: combineGuards([requireSeeker, searchCareTypeGuard]),
  },
];

export default searchRoutes;
